// import React, { useEffect, useState, useContext } from "react";
// import axios from "axios";
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Card,
//   CircularProgress,
//   Alert,
//   Snackbar,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import DeleteIcon from "@mui/icons-material/Delete";
// import { useNavigate } from "react-router-dom";
// import { AuthContext } from "../../AuthContext/AuthContext";
// import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";
// import { BASE_URL } from "../../Api/ApiUrls";
// import DeleteFailureAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteFailureAlert';
// import DeleteSuccessAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteSuccessAlert';
// import DeleteConfirmAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteConfirmAlert';

// const User_BankAuction = () => {
//   const navigate = useNavigate();
//   const { userId } = useContext(AuthContext);
// const [propertyToDelete, setPropertyToDelete] = useState(null);
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [locationLoadingId, setLocationLoadingId] = useState(null);
//   const [deletingId, setDeletingId] = useState(null);
// const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
// const [showDeleteFailure, setShowDeleteFailure] = useState(false);
// const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
// const [requestToDelete, setRequestToDelete] = useState(null);
// const [alertMessage, setAlertMessage] = useState("");

  
//   // State to track current image index for each card
//   const [currentImageIndices, setCurrentImageIndices] = useState({});

//   const colors = {
//     primary: "#1a1a1a",
//     background: "#efe7dd",
//     cardBg: "#ffffff",
//     muted: "#666",
//   };

//   // Currency formatter
//   const formatCurrency = (amount) => {
//     if (!amount) return "₹0";
//     const num = Number(amount);
//     if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
//     if (num >= 100000) return `₹${(num / 100000).toFixed(1)} L`;
//     if (num >= 1000) return `${Math.round(num / 1000)} K`;
//     return `₹${num.toLocaleString()}`;
//   };

//   // Get all image URLs
//   const getAllImageUrls = (docArray) => {
//     if (!docArray || docArray.length === 0) {
//       return [];
//     }
    
//     return docArray.map(doc => {
//       if (doc.document) {
//         if (doc.document.startsWith('/')) {
//           return `${BASE_URL}${doc.document}`;
//         }
//         return doc.document;
//       }
//       return null;
//     }).filter(url => url !== null);
//   };

//   const handleCardClick = (item) => {
//     if (item.lat && item.long) {
//       localStorage.setItem('propertyLat', item.lat);
//       localStorage.setItem('propertyLong', item.long);
//     }
//     // navigate(`/User_BankAuction_detail/${item.bankprop_id}`);
//     navigate(`/Post_Bankcard_indetail/${item.bankprop_id}`);

//   };

//   // Carousel navigation functions
//   const nextImage = (e, bankpropId, totalImages) => {
//     e.stopPropagation();
//     setCurrentImageIndices(prev => {
//       const currentIndex = prev[bankpropId] || 0;
//       const newIndex = (currentIndex + 1) % totalImages;
//       return { ...prev, [bankpropId]: newIndex };
//     });
//   };

//   const prevImage = (e, bankpropId, totalImages) => {
//     e.stopPropagation();
//     setCurrentImageIndices(prev => {
//       const currentIndex = prev[bankpropId] || 0;
//       const newIndex = (currentIndex - 1 + totalImages) % totalImages;
//       return { ...prev, [bankpropId]: newIndex };
//     });
//   };

//   // Handle dot click
//   const handleDotClick = (e, bankpropId, index) => {
//     e.stopPropagation();
//     setCurrentImageIndices(prev => ({ ...prev, [bankpropId]: index }));
//   };

//   // FIXED: Location click handler - Same as in User_BankAuction_detail
//   const handleLocationClick = (e, item) => {
//     e.stopPropagation();
//     setLocationLoadingId(item.bankprop_id);
    
//     const openInMaps = (url) => {
//       setLocationLoadingId(null);
//       window.open(url, '_blank', 'noopener,noreferrer');
//     };

//     // Check if we have latitude and longitude
//     if (item.lat && item.long) {
//       const locationString = `${item.lat},${item.long}`;
//       const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationString)}`;
      
//       if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           (position) => {
//             const userLat = position.coords.latitude;
//             const userLng = position.coords.longitude;
            
//             // Create directions URL from user's location to property
//             const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${item.lat},${item.long}&travelmode=driving`;
//             openInMaps(mapsUrl);
//           },
//           (error) => {
//             console.error("Error getting location:", error);
//             // Fallback to just showing the location
//             openInMaps(fallbackUrl);
//           },
//           { timeout: 10000 }
//         );
//       } else {
//         openInMaps(fallbackUrl);
//       }
//     } else {
//       // If no lat/long, try to use location text
//       const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.location || `${item.city_town}, ${item.area_town}`)}`;
//       openInMaps(fallbackUrl);
//     }
//   };

// const handleDeleteProperty = (e, property) => {
//   e.stopPropagation();
//   setPropertyToDelete(property);
//   setShowDeleteConfirm(true);
// };
// const performDelete = async () => {
//   if (!propertyToDelete) return;
  
//   setDeletingId(propertyToDelete.bankprop_id);
  
//   try {
//     await axios.delete(`${BASE_URL}/auction-property/${propertyToDelete.bankprop_id}/`);
    
//     // Remove the deleted property from state
//     setData(prevData => prevData.filter(item => item.bankprop_id !== propertyToDelete.bankprop_id));
    
//     setAlertMessage("Auction property deleted successfully!");
//     setShowDeleteSuccess(true);
    
//   } catch (err) {
//     console.error("Error deleting property:", err);
//     setAlertMessage("Failed to delete auction property. Please try again.");
//     setShowDeleteFailure(true);
//   } finally {
//     setDeletingId(null);
//     setPropertyToDelete(null);
//   }
// };



//  useEffect(() => {
//   const fetchData = async () => {
//     try {
//       const res = await axios.post(
//         `${BASE_URL}/bank-properties/filter/`,
//         {
//           include: {
//             user_id: Number(userId),
//           },
//           exclude: {},
//         }
//       );

//       setData(res.data?.data || []);
//       setLoading(false);
//     } catch (err) {
//       console.error(err);
//       setError("Failed to load bank auction properties");
//       setLoading(false);
//     }
//   };

//   if (userId) {
//     fetchData();
//   } else {
//     setError("User not authenticated");
//     setLoading(false);
//   }
// }, [userId]);

//   // LOADING
//   if (loading) {
//     return (
//       <Box
//         sx={{
//           minHeight: "100vh",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           gap: 2,
//           backgroundColor: colors.background,
//         }}
//       >
//         <CircularProgress sx={{ color: "#000" }} />
//         <Typography fontWeight={600}>
//           Loading Auction Properties...
//         </Typography>
//       </Box>
//     );
//   }

//   // ERROR
//   if (error) {
//     return (
//       <Box
//         sx={{
//           minHeight: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           backgroundColor: colors.background,
//         }}
//       >
//         <Typography color="error">{error}</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         display: "flex",
//         flexDirection: "column",
//         backgroundColor: colors.background,
//       }}
//     >
//       {/* HEADER */}
//       <AppBar position="fixed" sx={{ backgroundColor: colors.primary,zIndex: 1200, }}>
//         <Toolbar>
//           <IconButton onClick={() => navigate(-1)} sx={{ color: "#fff" }}>
//             <ArrowBackIosNewIcon />
//           </IconButton>
//           <Typography sx={{ ml: 2 }} fontWeight={600}>
//             My Auction Properties
//           </Typography>
//         </Toolbar>
//       </AppBar>

//       {/* CONTENT */}
//       <Box sx={{ p: 1.5, pb: 10 ,        pt: { xs: '80px', sm: '100px' },  
// }}>
//         {data.length === 0 ? (
//           <Typography textAlign="center" sx={{ mt: 4 }}>
//             No auction properties found
//           </Typography>
//         ) : (
//           data.map((item) => {
//             const imageUrls = getAllImageUrls(item.bank_pro_doc);
//             const currentIndex = currentImageIndices[item.bankprop_id] || 0;
//             const hasMultipleImages = imageUrls.length > 1;
//             const isLocationLoading = locationLoadingId === item.bankprop_id;
//             const isDeleting = deletingId === item.bankprop_id;
            
//             return (
//               <Card
//                 key={item.bankprop_id}
//                 onClick={() => handleCardClick(item)}
//                 sx={{
//                   mb: 1.5,
//                   borderRadius: 3,
//                   p: 1.5,
//                   boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
//                   cursor: "pointer",
//                   position: "relative",
//                 }}
//               >
//               <Box sx={{ display: "flex", gap: 1.5 }}>
  
//   {/* ✅ LEFT SIDE (IMAGE + STATUS) */}
//   <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    
//     {/* IMAGE BOX */}
//     <Box
//       sx={{
//         width: 90,
//         height: 130,
//         borderRadius: 2,
//         backgroundColor: "#e6e0d4",
//         position: "relative",
//         overflow: "hidden",
//         flexShrink: 0,
//       }}
//     >
//       {imageUrls.length > 0 ? (
//         <>
//           <img
//             src={imageUrls[currentIndex]}
//             alt="Property"
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//             }}
//             onError={(e) => {
//               e.target.style.display = "none";
//               const container = e.target.parentElement;
//               if (container.querySelector(".no-image-text")) return;

//               const noImageText = document.createElement("span");
//               noImageText.className = "no-image-text";
//               noImageText.textContent = "No Image";
//               noImageText.style.cssText = `
//                 position: absolute;
//                 top: 50%;
//                 left: 50%;
//                 transform: translate(-50%, -50%);
//                 font-weight: 700;
//                 font-size: 0.7rem;
//                 color: #555;
//               `;
//               container.appendChild(noImageText);
//             }}
//           />

//           {/* Carousel Buttons */}
//           {hasMultipleImages && (
//             <>
//               <IconButton
//                 onClick={(e) =>
//                   prevImage(e, item.bankprop_id, imageUrls.length)
//                 }
//                 sx={{
//                   position: "absolute",
//                   left: 2,
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   backgroundColor: "rgba(255,255,255,0.8)",
//                   width: 20,
//                   height: 20,
//                   minWidth: 20,
//                   padding: 0,
//                 }}
//               >
//                 <ChevronLeftIcon sx={{ fontSize: 14 }} />
//               </IconButton>

//               <IconButton
//                 onClick={(e) =>
//                   nextImage(e, item.bankprop_id, imageUrls.length)
//                 }
//                 sx={{
//                   position: "absolute",
//                   right: 2,
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   backgroundColor: "rgba(255,255,255,0.8)",
//                   width: 20,
//                   height: 20,
//                   minWidth: 20,
//                   padding: 0,
//                 }}
//               >
//                 <ChevronRightIcon sx={{ fontSize: 14 }} />
//               </IconButton>

//               {/* Dots */}
//               <Box
//                 sx={{
//                   position: "absolute",
//                   bottom: 4,
//                   left: 0,
//                   right: 0,
//                   display: "flex",
//                   justifyContent: "center",
//                   gap: 0.5,
//                 }}
//               >
//                 {imageUrls.map((_, index) => (
//                   <Box
//                     key={index}
//                     onClick={(e) =>
//                       handleDotClick(e, item.bankprop_id, index)
//                     }
//                     sx={{
//                       width: 6,
//                       height: 6,
//                       borderRadius: "50%",
//                       backgroundColor:
//                         index === currentIndex ? "#1976d2" : "#ccc",
//                       cursor: "pointer",
//                     }}
//                   />
//                 ))}
//               </Box>
//             </>
//           )}
//         </>
//       ) : (
//         <Box
//           sx={{
//             width: "100%",
//             height: "100%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <Typography
//             sx={{
//               fontWeight: 700,
//               fontSize: "0.7rem",
//               color: "#555",
//             }}
//           >
//             No Image
//           </Typography>
//         </Box>
//       )}
//     </Box>

//    {/* ✅ STATUS BELOW IMAGE */}
// {item.admin_status && (
//   <Typography
//     sx={{
//       mt: 0.5,
//       fontSize: "0.65rem",
//       fontWeight: "bold",
//       textAlign: "center",
//       px: 1,
//       py: 0.3,
//       border: `1px solid ${
//         item.admin_status.toLowerCase() === "approved"
//           ? "#4caf50" // Green
//           : item.admin_status.toLowerCase() === "rejected"
//           ? "#f44336" // Red
//           : item.admin_status.toLowerCase() === "pending"
//           ? "#ff9800" // Orange
//           : "#9e9e9e" // Default Gray
//       }`,
//       color: "#000000be",
//       backgroundColor: "#fff",
//       width: "100%",
//     }}
//   >
//     {item.admin_status}
//   </Typography>
// )}
//   </Box>

//   {/* ✅ RIGHT CONTENT */}
//   {/* ✅ RIGHT CONTENT */}
// <Box sx={{ flex: 1, minWidth: 0, pr: 1, display: "flex", flexDirection: "column" }}> 
//     <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
//       <Box
//         sx={{
//           backgroundColor: "#1a1a1a",
//           color: "#fff",
//           px: 1,
//           borderRadius: 1.5,
//           fontSize: "0.75rem",
//           fontWeight: 600,
//         }}
//       >
//         {formatCurrency(item.reserve_price)}
//       </Box>
//     </Box>

//     <Typography fontSize="0.75rem" noWrap>
//       <strong>Property:</strong> {item.property_type}
//     </Typography>

//     <Typography fontSize="0.75rem" noWrap>
//       <strong>City/Town:</strong> {item.city_town}
//     </Typography>

//     <Typography fontSize="0.75rem" noWrap>
//       <strong>Location:</strong> {item.location}
//     </Typography>

//     <Typography fontSize="0.75rem">
//       <strong>Auction:</strong>{" "}
//       {new Date(item.auction_start_datetime).toLocaleDateString()} -{" "}
//       {new Date(item.auction_end_datetime).toLocaleDateString()}
//     </Typography>

//     <Typography fontSize="0.75rem" noWrap>
//       <strong>Bank:</strong>{" "}
//       {item.bank_name || "State Bank of India"}
//     </Typography>

//     <Box
//       sx={{
//         display: "flex",
//         justifyContent: "flex-end",
//         alignItems: "center",
//         gap: 1,
//        mt: "auto",
//       }}
//     >
//       {/* Location */}
//       <Box
//         onClick={(e) => handleLocationClick(e, item)}
//         sx={{
//           display: "inline-flex",
//           alignItems: "center",
//           gap: 0.4,
//           border: "1px solid #000",
//           borderRadius: 1.5,
//           px: 0.8,
//           py: 0.3,
//           cursor: "pointer",
//         }}
//       >
//         <Typography sx={{ fontSize: "0.7rem" }}>
//           Location
//         </Typography>

//         {isLocationLoading ? (
//           <CircularProgress size={12} />
//         ) : (
//           <LocationOnIcon sx={{ fontSize: "0.9rem" }} />
//         )}
//       </Box>

//       {/* Delete */}
//       <IconButton
//         onClick={(e) => handleDeleteProperty(e, item)}
//         disabled={isDeleting}
//       >
//         {isDeleting ? (
//           <CircularProgress size={20} />
//         ) : (
//           <DeleteIcon sx={{ color: "#ff4444" }} />
//         )}
//       </IconButton>
//     </Box>
//   </Box>
// </Box>
//               </Card>
//             );
//           })
//         )}
//       </Box>

//   {/* Delete Success */}
//       {showDeleteSuccess && (
//         <DeleteSuccessAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowDeleteSuccess(false);
//             setAlertMessage("");
//           }}
//         />
//       )}
      
//       {/* Delete Failure */}
//       {showDeleteFailure && (
//         <DeleteFailureAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowDeleteFailure(false);
//             setAlertMessage("");
//           }}
//         />
//       )}
// {showDeleteConfirm && propertyToDelete && (
//   <DeleteConfirmAlert
//     message={`Are you sure you want to delete this auction property? This action cannot be undone.`}
//     onOk={() => {
//       setShowDeleteConfirm(false);
//       performDelete();
//     }}
//     onCancel={() => {
//       setShowDeleteConfirm(false);
//       setPropertyToDelete(null);
//     }}
//   />
// )}
//       {/* BOTTOM NAV */}
//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
//         <CustomBottomNavbar />
//       </Box>


//     </Box>
//   );
// };

// export default User_BankAuction;

//============================


// import React, { useEffect, useState, useContext } from "react";
// import axios from "axios";
// import {
//   Box,
//   Card,
//   CardMedia,
//   Typography,
//   IconButton,
//   Button,
//   CircularProgress,
//   Chip,
//   Menu,
//   MenuItem,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import {
//   FavoriteBorder,
//   PeopleAlt,
//   Share,
//   Call,
//   LocationOn,
//   ChevronLeft,
//   ChevronRight,
//   MoreVert,
//   DeleteOutline,
//   AccessTime as AccessTimeIcon,
//   Visibility as VisibilityIcon,
// } from "@mui/icons-material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
// import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
// import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
// import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
// import RocketIcon from "@mui/icons-material/RocketLaunch";
// import { useNavigate } from "react-router-dom";
// import { AuthContext } from "../../AuthContext/AuthContext";
// import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";
// import { BASE_URL } from "../../Api/ApiUrls";
// import DeleteFailureAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteFailureAlert';
// import DeleteSuccessAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteSuccessAlert';
// import DeleteConfirmAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteConfirmAlert';

// const User_BankAuction = () => {
//   const navigate = useNavigate();
//   const { userId } = useContext(AuthContext);
//   const [propertyToDelete, setPropertyToDelete] = useState(null);
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [locationLoadingId, setLocationLoadingId] = useState(null);
//   const [deletingId, setDeletingId] = useState(null);
//   const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
//   const [showDeleteFailure, setShowDeleteFailure] = useState(false);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");
  
//   // State to track current image index for each card
//   const [currentImageIndices, setCurrentImageIndices] = useState({});
  
//   // Menu state
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [menuPropertyId, setMenuPropertyId] = useState(null);

//   const colors = {
//     primary: "#1a1a1a",
//     background: "#efe7dd",
//     cardBg: "#ffffff",
//     muted: "#666",
//   };

//   // Currency formatter (kept as is, but could be changed to match Buy if needed)
//   const formatCurrency = (amount) => {
//     if (!amount) return "₹0";
//     const num = Number(amount);
//     if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
//     if (num >= 100000) return `₹${(num / 100000).toFixed(1)} L`;
//     if (num >= 1000) return `${Math.round(num / 1000)} K`;
//     return `₹${num.toLocaleString()}`;
//   };

//   // Get all image URLs
//   const getAllImageUrls = (docArray) => {
//     if (!docArray || docArray.length === 0) {
//       return [];
//     }
    
//     return docArray.map(doc => {
//       if (doc.document) {
//         if (doc.document.startsWith('/')) {
//           return `${BASE_URL}${doc.document}`;
//         }
//         return doc.document;
//       }
//       return null;
//     }).filter(url => url !== null);
//   };

//   const handleCardClick = (item) => {
//     if (item.lat && item.long) {
//       localStorage.setItem('propertyLat', item.lat);
//       localStorage.setItem('propertyLong', item.long);
//     }
//     navigate(`/Post_Bankcard_indetail/${item.bankprop_id}`);
//   };

//   // Carousel navigation functions
//   const nextImage = (e, bankpropId, totalImages) => {
//     e.stopPropagation();
//     setCurrentImageIndices(prev => {
//       const currentIndex = prev[bankpropId] || 0;
//       const newIndex = (currentIndex + 1) % totalImages;
//       return { ...prev, [bankpropId]: newIndex };
//     });
//   };

//   const prevImage = (e, bankpropId, totalImages) => {
//     e.stopPropagation();
//     setCurrentImageIndices(prev => {
//       const currentIndex = prev[bankpropId] || 0;
//       const newIndex = (currentIndex - 1 + totalImages) % totalImages;
//       return { ...prev, [bankpropId]: newIndex };
//     });
//   };

//   // Handle dot click
//   const handleDotClick = (e, bankpropId, index) => {
//     e.stopPropagation();
//     setCurrentImageIndices(prev => ({ ...prev, [bankpropId]: index }));
//   };

//   // Location click handler
//   const handleLocationClick = (e, item) => {
//     e.stopPropagation();
//     setLocationLoadingId(item.bankprop_id);
    
//     const openInMaps = (url) => {
//       setLocationLoadingId(null);
//       window.open(url, '_blank', 'noopener,noreferrer');
//     };

//     if (item.lat && item.long) {
//       const locationString = `${item.lat},${item.long}`;
//       const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationString)}`;
      
//       if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           (position) => {
//             const userLat = position.coords.latitude;
//             const userLng = position.coords.longitude;
//             const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${item.lat},${item.long}&travelmode=driving`;
//             openInMaps(mapsUrl);
//           },
//           (error) => {
//             console.error("Error getting location:", error);
//             openInMaps(fallbackUrl);
//           },
//           { timeout: 10000 }
//         );
//       } else {
//         openInMaps(fallbackUrl);
//       }
//     } else {
//       const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.location || `${item.city_town}, ${item.area_town}`)}`;
//       openInMaps(fallbackUrl);
//     }
//   };

//   const handleDeleteProperty = (e, property) => {
//     e.stopPropagation();
//     setPropertyToDelete(property);
//     setShowDeleteConfirm(true);
//   };

//   const performDelete = async () => {
//     if (!propertyToDelete) return;
    
//     setDeletingId(propertyToDelete.bankprop_id);
    
//     try {
//       await axios.delete(`${BASE_URL}/auction-property/${propertyToDelete.bankprop_id}/`);
//       setData(prevData => prevData.filter(item => item.bankprop_id !== propertyToDelete.bankprop_id));
//       setAlertMessage("Auction property deleted successfully!");
//       setShowDeleteSuccess(true);
//     } catch (err) {
//       console.error("Error deleting property:", err);
//       setAlertMessage("Failed to delete auction property. Please try again.");
//       setShowDeleteFailure(true);
//     } finally {
//       setDeletingId(null);
//       setPropertyToDelete(null);
//     }
//   };

//   const handleMenuOpen = (event, propertyId) => {
//     event.stopPropagation();
//     setAnchorEl(event.currentTarget);
//     setMenuPropertyId(propertyId);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//     setMenuPropertyId(null);
//   };

//   // Placeholder handlers to match Buy UI (since these actions might not exist for auction)
//   const handleShare = (e, property) => {
//     e.stopPropagation();
//     // Add share logic here if needed
//   };
  
//   const handleCallClick = (e, property) => {
//     e.stopPropagation();
//     // Add call logic here if needed
//   };

//   const handleWishlistClick = (propertyId, e) => {
//     e.stopPropagation();
//     // navigate(`/wishlist-users/${propertyId}`);
//   };

//   const handleMatchingBuyersClick = (propertyId, e) => {
//     e.stopPropagation();
//     // navigate(`/matching-buyers/${propertyId}`);
//   };

//   const handleViewListClick = (propertyId, e) => {
//     e.stopPropagation();
//     // navigate(`/viewlistpage/${propertyId}`);
//   };

//   const handleExtensionClick = () => {
//     navigate('/user-subscription');
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await axios.post(
//           `${BASE_URL}/bank-properties/filter/`,
//           {
//             include: {
//               user_id: Number(userId),
//             },
//             exclude: {},
//           }
//         );
//         setData(res.data?.data || []);
//         setLoading(false);
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load bank auction properties");
//         setLoading(false);
//       }
//     };

//     if (userId) {
//       fetchData();
//     } else {
//       setError("User not authenticated");
//       setLoading(false);
//     }
//   }, [userId]);

//   // ==================== RENDER CARD (BUY UI STYLE) ====================
//   const renderAuctionPropertyCard = (item) => {
//     const imageUrls = getAllImageUrls(item.bank_pro_doc);
//     const currentIndex = currentImageIndices[item.bankprop_id] || 0;
//     const hasMultipleImages = imageUrls.length > 1;
//     const isLocationLoading = locationLoadingId === item.bankprop_id;
//     const isDeleting = deletingId === item.bankprop_id;

//     return (
//       <Card
//         key={item.bankprop_id}
//         sx={{
//           mb: 1,
//           mx: 1,
//           borderRadius: 3,
//           boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
//           overflow: 'hidden',
//           transition: 'transform 0.2s ease-in-out',
//           '&:hover': { transform: 'scale(1.01)', boxShadow: '0 4px 16px rgba(0,0,0,0.12)' },
//         }}
//         onClick={() => handleCardClick(item)}
//       >
//         {/* TOP: image (left) + details (right) */}
//         <Box sx={{ display: 'flex', gap: 1, p: 1, pb: 1 }}>
          
//           {/* Image Column */}
//           <Box sx={{ position: 'relative', width: '50%', flexShrink: 0, borderRadius: 2.5, overflow: 'hidden' }}>
//             {imageUrls.length > 0 ? (
//               <CardMedia
//                 component="img"
//                 image={imageUrls[currentIndex]}
//                 alt="Property"
//                 sx={{ width: '100%', height: '100%', minHeight: 170, objectFit: 'cover' }}
//               />
//             ) : (
//               <Box sx={{ width: '100%', height: '100%', minHeight: 170, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#e6e0d4' }}>
//                 <Typography sx={{ fontWeight: 700, fontSize: '0.7rem', color: '#555' }}>No Image</Typography>
//               </Box>
//             )}

//             {/* <Box sx={{ position: 'absolute', top: 8, left: 8, backgroundColor: '#D9A441', color: '#FFFFFF', fontSize: '9px', fontWeight: 700, letterSpacing: '0.4px', px: 1, py: 0.4, borderRadius: '6px' }}>
//               FEATURED
//             </Box> */}

//             <Box sx={{ position: 'absolute', top: 8, right: 8, display: 'flex', gap: 0.7 }}>
//               <IconButton size="small" sx={{ bgcolor: 'rgba(255,255,255,0.9)', width: 26, height: 26, '&:hover': { bgcolor: '#fff' } }} onClick={(e) => handleShare(e, item)}>
//                 <Share sx={{ fontSize: 14 }} />
//               </IconButton>
//               <IconButton size="small" sx={{ bgcolor: 'rgba(255,255,255,0.9)', width: 26, height: 26, '&:hover': { bgcolor: '#fff' } }} onClick={(e) => handleMenuOpen(e, item.bankprop_id)}>
//                 <MoreVert sx={{ fontSize: 14 }} />
//               </IconButton>
//             </Box>

//             {imageUrls.length > 0 && (
//               <Box sx={{ position: 'absolute', bottom: 8, left: 8, backgroundColor: 'rgba(0,0,0,0.6)', color: '#FFFFFF', fontSize: '9px', fontWeight: 500, px: 1, py: 0.4, borderRadius: '6px', display: 'flex', alignItems: 'center', gap: 0.4 }}>
//                 <CollectionsOutlinedIcon sx={{ fontSize: 12 }} />
//                 {imageUrls.length} Photos
//               </Box>
//             )}

//             {hasMultipleImages && (
//               <>
//                 <IconButton sx={{ position: 'absolute', top: '50%', left: 4, opacity: 0, transform: 'translateY(-50%)', backgroundColor: 'rgba(255,255,255,0.3)', backdropFilter: 'blur(2px)', '&:hover': { opacity: 1, backgroundColor: 'rgba(255,255,255,0.5)' } }} onClick={(e) => prevImage(e, item.bankprop_id, imageUrls.length)}>
//                   <ChevronLeft fontSize="small" />
//                 </IconButton>
//                 <IconButton sx={{ position: 'absolute', top: '50%', right: 4, opacity: 0, transform: 'translateY(-50%)', backgroundColor: 'rgba(255,255,255,0.3)', backdropFilter: 'blur(2px)', '&:hover': { opacity: 1, backgroundColor: 'rgba(255,255,255,0.5)' } }} onClick={(e) => nextImage(e, item.bankprop_id, imageUrls.length)}>
//                   <ChevronRight fontSize="small" />
//                 </IconButton>
//               </>
//             )}
//           </Box>

//           {/* Details Column */}
//           <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
//             <Box>
//               <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#1a1a1a', lineHeight: 1.25, mb: 0.3 }} noWrap>
//                 {item.property_type || 'Bank Auction'}
//               </Typography>
//               <Typography sx={{ fontSize: '1.05rem', fontWeight: 700, color: '#D9A441' }} noWrap>
//                 {formatCurrency(item.reserve_price)}
//               </Typography>
//             </Box>

//             <Box sx={{ mt: 1 }}>
//               <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.6, mb: 0.6 }}>
//                 <LocationOn sx={{ fontSize: 15, color: '#8a8a8a', mt: '1px', flexShrink: 0 }} />
//                 <Typography sx={{ fontSize: '0.72rem', color: '#666', lineHeight: 1.3 }}>{item.location || `${item.city_town}, ${item.area_town}`}</Typography>
//               </Box>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}>
//                 <CalendarTodayOutlinedIcon sx={{ fontSize: 13, color: '#8a8a8a', flexShrink: 0 }} />
//                 <Typography sx={{ fontSize: '0.72rem', color: '#666' }}>
//                   {new Date(item.auction_start_datetime).toLocaleDateString()} - {new Date(item.auction_end_datetime).toLocaleDateString()}
//                 </Typography>
//               </Box>
//             </Box>

//             <Box sx={{ display: 'flex', gap: 1, mt: 1.2, flexWrap: 'wrap' }}>
//               {(() => {
//                 const status = !item.admin_status || item.admin_status === '' ? 'pending' : item.admin_status.toLowerCase();
//                 const getStyles = () => {
//                   switch (status) {
//                     case 'approved': return { color: '#4caf50', icon: <CheckCircleIcon sx={{ fontSize: 15 }} />, label: 'Approved' };
//                     case 'rejected': return { color: '#f44336', icon: <CancelIcon sx={{ fontSize: 15 }} />, label: 'Rejected' };
//                     default: return { color: '#ff9800', icon: <HourglassEmptyIcon sx={{ fontSize: 15 }} />, label: 'Pending' };
//                   }
//                 };
//                 const { color, icon, label } = getStyles();
//                 return (
//                   <Chip icon={icon} label={label} variant="outlined" sx={{ height: 26, borderColor: color, borderRadius: '6px', color, fontWeight: 600, fontSize: '0.68rem', '& .MuiChip-icon': { color } }} />
//                 );
//               })()}

//               <Button size="small" variant="outlined" startIcon={<Call sx={{ fontSize: 14 }} />} onClick={(e) => handleCallClick(e, item)} sx={{ textTransform: 'none', borderRadius: '6px', borderColor: '#D9A441', color: '#D9A441', fontSize: '0.68rem', fontWeight: 600, px: 1.4, py: 0.2, '&:hover': { borderColor: '#D9A441', backgroundColor: 'rgba(217,164,65,0.06)' } }}>
//                 Call
//               </Button>
//             </Box>
//           </Box>
//         </Box>

//         {/* FACING / AREA / POSTED BY (Mapped to Bank/Property/City) */}
//         <Box sx={{ display: 'flex', px: 1, py: 1.2, border: '1px solid #E8E5E0', borderRadius: '8px', backgroundColor: '#fff', overflow: 'hidden', mx: 1 }}>
//           {[
//             { label: 'Property', value: item.property_type || 'N/A' },
//             { label: 'City/Town', value: item.city_town || 'N/A' },
//             { label: 'Bank', value: item.bank_name || 'SBI' },
//           ].map((item, index) => (
//             <Box key={index} sx={{ flex: 1, textAlign: 'center', position: 'relative', ...(index < 2 && { '&::after': { content: '""', position: 'absolute', right: 0, top: '15%', height: '70%', width: '1px', backgroundColor: '#E8E5E0' } }) }}>
//               <Typography sx={{ fontSize: '0.68rem', color: '#999', mb: 0.3 }}>{item.label}</Typography>
//               <Typography sx={{ fontSize: '0.8rem', fontWeight: 700, color: '#222' }} noWrap>{item.value}</Typography>
//             </Box>
//           ))}
//         </Box>

//         {/* WISHLIST / MATCHING / DELETE */}
//         {/* <Box sx={{ display: 'flex', gap: 0.5, px: 0.5, py: 0.5 }}>
//           <Button startIcon={<FavoriteBorder sx={{ fontSize: 15 }} />} variant="outlined" onClick={(e) => handleWishlistClick(item.bankprop_id, e)} sx={{ flex: 1, textTransform: 'none', borderRadius: '6px', borderColor: '#D9A441', color: '#D9A441', fontWeight: 600, fontSize: '0.68rem', '&:hover': { borderColor: '#D9A441', backgroundColor: 'rgba(217,164,65,0.06)' } }}>
//             Wishlist (0)
//           </Button>

//           <Button startIcon={<PeopleAlt sx={{ fontSize: 15 }} />} variant="outlined" onClick={(e) => handleMatchingBuyersClick(item.bankprop_id, e)} sx={{ flex: 1, textTransform: 'none', borderRadius: '6px', borderColor: '#2ECC71', color: '#2ECC71', fontWeight: 600, fontSize: '0.68rem', '&:hover': { borderColor: '#2ECC71', backgroundColor: 'rgba(46,204,113,0.06)' } }}>
//             Matching (0)
//           </Button>

//           <Button startIcon={<DeleteOutline sx={{ fontSize: 15 }} />} variant="outlined" onClick={(e) => handleDeleteProperty(e, item)} sx={{ flex: 1, minWidth: 0, textTransform: 'none', borderRadius: '6px', borderColor: '#E74C3C', color: '#E74C3C', fontWeight: 600, fontSize: '0.68rem', '&:hover': { borderColor: '#E74C3C', backgroundColor: 'rgba(231,76,60,0.06)' } }}>
//             Delete
//           </Button>
//         </Box> */}

//         {/* EXTEND / VIEWS / DAYS LEFT */}
//         {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 0.5, px: 1, pb: 1, flexWrap: 'wrap' }}>
//           <Box sx={{ display: 'flex', gap: 0.8 }}>
//             <Button variant="outlined" onClick={handleExtensionClick} startIcon={<AccessTimeIcon sx={{ fontSize: 16, color: '#c3790b' }} />} sx={{ textTransform: 'none', borderRadius: '6px', fontSize: '0.7rem', fontWeight: 500, backgroundColor: '#fff', borderColor: '#d0d0d0', color: '#c3790b', px: 1, whiteSpace: 'nowrap', '&:hover': { backgroundColor: '#f5f5f5', borderColor: '#d0d0d0' } }}>
//               Extend Your Post
//             </Button>

//             <Button startIcon={<VisibilityIcon sx={{ fontSize: 14, color: '#000' }} />} variant="outlined" disableElevation onClick={(e) => handleViewListClick(item.bankprop_id, e)} sx={{ textTransform: 'none', borderRadius: '6px', fontSize: '0.65rem', fontWeight: 600, backgroundColor: '#fff', color: '#000', border: '1px solid #cec6c6', px: 1.3, py: 0.4, whiteSpace: 'nowrap', '&:hover': { backgroundColor: '#f5f5f5', border: '1px solid #cec6c6' } }}>
//               Views (0)
//             </Button>
//           </Box>

//           <Typography sx={{ fontWeight: 700, fontSize: '0.8rem', whiteSpace: 'nowrap', color: '#1976d2' }}>
//             No Expiry
//           </Typography>
//         </Box> */}

//         {/* Menu for Edit/Delete */}
//         <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }} onClick={(e) => e.stopPropagation()}>
//           <MenuItem onClick={(e) => { e.stopPropagation(); handleMenuClose(); }}>Edit</MenuItem>
//           <MenuItem onClick={(e) => { e.stopPropagation(); handleDeleteProperty(e, item); handleMenuClose(); }}>Delete</MenuItem>
//         </Menu>
//       </Card>
//     );
//   };

//   // LOADING
//   if (loading) {
//     return (
//       <Box sx={{ backgroundColor: 'rgb(184, 174, 162)', minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 3 }}>
//         <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
//         <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>Loading Auction Properties...</Typography>
//       </Box>
//     );
//   }

//   // ERROR
//   if (error) {
//     return (
//       <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.background }}>
//         <Typography color="error">{error}</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '120vh' }}>
//       {/* Fixed Top Section */}
//       <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1200, backgroundColor: 'rgb(239, 231, 221)', px: 1, py: 1, boxShadow: '0 2px 5px rgba(0,0,0,0.05)' }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//           <IconButton onClick={() => navigate(-1)} sx={{ color: '#000' }}>
//             <ArrowBackIosNewIcon />
//           </IconButton>
//           <Typography variant="h6" sx={{ fontWeight: 'bold', ml: 1 }}>My Auction Properties</Typography>
//         </Box>

//         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 1 }}>
//           <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
//             {data.length > 0 && (
//               <Button variant="contained" color="primary" startIcon={<RocketIcon sx={{ fontSize: 18 }} />} sx={{ fontSize: '0.75rem', fontWeight: 600, textTransform: 'none', backgroundColor: '#000', color: 'gold', borderRadius: '8px', padding: '6px 16px', '&:hover': { backgroundColor: '#E0961E' } }}>
//                 Boost Your Property
//               </Button>
//             )}
//           </Box>
//         </Box>
//       </Box>

//       {/* Property List Section */}
//       <Box sx={{ pt: { xs: '140px', sm: '150px' }, pb: 8 }}>
//         {data.length === 0 ? (
//           <Typography textAlign="center" sx={{ mt: 4 }}>No auction properties found</Typography>
//         ) : (
//           data.map((item) => renderAuctionPropertyCard(item))
//         )}
//       </Box>

//       {/* ALERTS */}
//       {showDeleteSuccess && <DeleteSuccessAlert message={alertMessage} onClose={() => { setShowDeleteSuccess(false); setAlertMessage(""); }} />}
//       {showDeleteFailure && <DeleteFailureAlert message={alertMessage} onClose={() => { setShowDeleteFailure(false); setAlertMessage(""); }} />}
//       {showDeleteConfirm && propertyToDelete && (
//         <DeleteConfirmAlert
//           message={`Are you sure you want to delete this auction property? This action cannot be undone.`}
//           onOk={() => { setShowDeleteConfirm(false); performDelete(); }}
//           onCancel={() => { setShowDeleteConfirm(false); setPropertyToDelete(null); }}
//         />
//       )}

//       {/* BOTTOM NAV */}
//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
//         <CustomBottomNavbar />
//       </Box>
//     </Box>
//   );
// };

// export default User_BankAuction;
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  IconButton,
  Button,
  CircularProgress,
  Menu,
  MenuItem,
  Avatar,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {
  FavoriteBorder,
  PeopleAlt,
  Share,
  LocationOn,
  ChevronLeft,
  ChevronRight,
  MoreVert,
  DeleteOutline,
  AccessTime as AccessTimeIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import RocketIcon from "@mui/icons-material/RocketLaunch";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWork";
import StraightenOutlinedIcon from "@mui/icons-material/Straighten";
import ExploreOutlinedIcon from "@mui/icons-material/Explore";
import AddRoadOutlinedIcon from "@mui/icons-material/AddRoad";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAlt";
import TagOutlinedIcon from "@mui/icons-material/Tag";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalance";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../AuthContext/AuthContext";
import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";
import { BASE_URL } from "../../Api/ApiUrls";
import DeleteFailureAlert from "../../../Components/Users/Alertpage/DeleteAlert/DeleteFailureAlert";
import DeleteSuccessAlert from "../../../Components/Users/Alertpage/DeleteAlert/DeleteSuccessAlert";
import DeleteConfirmAlert from "../../../Components/Users/Alertpage/DeleteAlert/DeleteConfirmAlert";

const User_BankAuction = () => {
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);
  const [propertyToDelete, setPropertyToDelete] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [locationLoadingId, setLocationLoadingId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [showDeleteFailure, setShowDeleteFailure] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [currentImageIndices, setCurrentImageIndices] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuPropertyId, setMenuPropertyId] = useState(null);

  const colors = {
    primary: "#3B2314",
    gold: "#B8860B",
    goldSoft: "rgba(184,134,11,0.10)",
    background: "rgb(239, 231, 221)",
    cardBackground: "#FFFFFF",
    line: "#E8E5E0",
    textDark: "#1a1a1a",
    textLight: "#FFFFFF",
    textMuted: "#8a8a8a",
    danger: "#E74C3C",
    approved: "#2E7D32",
    approvedBg: "#E8F5E9",
    pending: "#F57C00",
    pendingBg: "#FFF3E0",
    rejected: "#C62828",
    rejectedBg: "#FFEBEE",
    specBg: "#FAF8F5",
  };

  /* ==================== HELPERS ==================== */

  const formatCurrency = (amount) => {
    if (!amount) return "₹0";
    const num = Number(amount);
    if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `₹${(num / 100000).toFixed(1)} L`;
    if (num >= 1000) return `₹${(num / 1000).toFixed(1)} K`;
    return `₹${num.toLocaleString()}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Not specified";
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  };

  const formatDateLong = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const calculateDaysLeft = (expiredDate) => {
    if (!expiredDate) return null;
    const now = new Date();
    const expiry = new Date(expiredDate);
    const diffTime = expiry - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

  const getDaysLeftForAuction = (item) => {
    if (item.auction_end_datetime) {
      return calculateDaysLeft(item.auction_end_datetime);
    }
    if (item.expired_date) {
      return calculateDaysLeft(item.expired_date);
    }
    return null;
  };

  const getStatusStyles = (status) => {
    const s = (status || "").toLowerCase();
    switch (s) {
      case "approved":
        return {
          color: colors.approved,
          bg: colors.approvedBg,
          border: colors.approved,
          icon: <CheckCircleIcon sx={{ fontSize: 13 }} />,
          label: "Approved",
        };
      case "rejected":
        return {
          color: colors.rejected,
          bg: colors.rejectedBg,
          border: colors.rejected,
          icon: <CancelIcon sx={{ fontSize: 13 }} />,
          label: "Rejected",
        };
      default:
        return {
          color: colors.pending,
          bg: colors.pendingBg,
          border: colors.pending,
          icon: <HourglassEmptyIcon sx={{ fontSize: 13 }} />,
          label: "Pending",
        };
    }
  };

  const getAllImageUrls = (docArray) => {
    if (!docArray || docArray.length === 0) return [];
    return docArray
      .map((doc) => {
        if (doc.document) {
          if (doc.document.startsWith("/")) return `${BASE_URL}${doc.document}`;
          return doc.document;
        }
        return null;
      })
      .filter((url) => url !== null);
  };

  /* ==================== HANDLERS ==================== */

  const handleCardClick = (item) => {
    if (item.lat && item.long) {
      localStorage.setItem("propertyLat", item.lat);
      localStorage.setItem("propertyLong", item.long);
    }
    navigate(`/Post_Bankcard_indetail/${item.bankprop_id}`);
  };

  const nextImage = (e, bankpropId, totalImages) => {
    e.stopPropagation();
    setCurrentImageIndices((prev) => {
      const currentIndex = prev[bankpropId] || 0;
      const newIndex = (currentIndex + 1) % totalImages;
      return { ...prev, [bankpropId]: newIndex };
    });
  };

  const prevImage = (e, bankpropId, totalImages) => {
    e.stopPropagation();
    setCurrentImageIndices((prev) => {
      const currentIndex = prev[bankpropId] || 0;
      const newIndex = (currentIndex - 1 + totalImages) % totalImages;
      return { ...prev, [bankpropId]: newIndex };
    });
  };

  const handleLocationClick = (e, item) => {
    e.stopPropagation();
    setLocationLoadingId(item.bankprop_id);

    const openInMaps = (url) => {
      setLocationLoadingId(null);
      window.open(url, "_blank", "noopener,noreferrer");
    };

    if (item.lat && item.long) {
      const locationString = `${item.lat},${item.long}`;
      const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        locationString
      )}`;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;
            const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${item.lat},${item.long}&travelmode=driving`;
            openInMaps(mapsUrl);
          },
          () => openInMaps(fallbackUrl),
          { timeout: 10000 }
        );
      } else {
        openInMaps(fallbackUrl);
      }
    } else {
      const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        item.location || `${item.city_town}, ${item.area_town}`
      )}`;
      openInMaps(fallbackUrl);
    }
  };

  const handleDeleteProperty = (e, property) => {
    e.stopPropagation();
    setPropertyToDelete(property);
    setShowDeleteConfirm(true);
  };

  const performDelete = async () => {
    if (!propertyToDelete) return;
    setDeletingId(propertyToDelete.bankprop_id);
    try {
      await axios.delete(`${BASE_URL}/auction-property/${propertyToDelete.bankprop_id}/`);
      setData((prevData) =>
        prevData.filter((item) => item.bankprop_id !== propertyToDelete.bankprop_id)
      );
      setAlertMessage("Auction property deleted successfully!");
      setShowDeleteSuccess(true);
    } catch (err) {
      console.error("Error deleting property:", err);
      setAlertMessage("Failed to delete auction property. Please try again.");
      setShowDeleteFailure(true);
    } finally {
      setDeletingId(null);
      setPropertyToDelete(null);
    }
  };

  const handleMenuOpen = (event, propertyId) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setMenuPropertyId(propertyId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuPropertyId(null);
  };

  const handleEditClick = (e, item) => {
    e.stopPropagation();
    navigate(`/user-edit-bank-auction/${item.bankprop_id}`);
  };

  const handleShare = (e, property) => {
    e.stopPropagation();
  };

  const handleCallClick = (e, property) => {
    e.stopPropagation();
  };

  const handleWishlistClick = (propertyId, e) => {
    e.stopPropagation();
  };

  const handleMatchingBuyersClick = (propertyId, e) => {
    e.stopPropagation();
  };

  const handleViewListClick = (propertyId, e) => {
    e.stopPropagation();
  };

  const handleExtensionClick = (e) => {
    e.stopPropagation();
    navigate("/user-subscription");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.post(`${BASE_URL}/bank-properties/filter/`, {
          include: { user_id: Number(userId) },
          exclude: {},
        });
        setData(res.data?.data || []);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError("Failed to load bank auction properties");
        setLoading(false);
      }
    };

    if (userId) {
      fetchData();
    } else {
      setError("User not authenticated");
      setLoading(false);
    }
  }, [userId]);

  /* ==================== SPEC CELL ==================== */

  const SpecCell = ({ icon, label, value, index, total }) => (
    <Box
      sx={{
        px: 1.2,
        py: 1,
        position: "relative",
        minWidth: 0,
        display: "flex",
        alignItems: "flex-start",
        gap: 0.8,
        ...(index % 2 === 0 &&
          index !== total - 1 && {
            "&::after": {
              content: '""',
              position: "absolute",
              right: 0,
              top: "18%",
              height: "64%",
              width: "1px",
              backgroundColor: colors.line,
            },
          }),
        ...(index < total - (total % 2 === 0 ? 2 : 1) && {
          borderBottom: `1px solid ${colors.line}`,
        }),
      }}
    >
      <Box
        sx={{
          width: 26,
          height: 26,
          borderRadius: "6px",
          backgroundColor: "#F3EFE8",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          mt: 0.2,
          color: "#8a7a5c",
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "0.6rem",
            color: colors.textMuted,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            fontWeight: 600,
            mb: 0.2,
            lineHeight: 1.1,
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontSize: "0.78rem",
            fontWeight: 700,
            color: colors.textDark,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {value || "Not specified"}
        </Typography>
      </Box>
    </Box>
  );

  /* ==================== CARD ==================== */

  const renderAuctionPropertyCard = (item) => {
    const imageUrls = getAllImageUrls(item.bank_pro_doc);
    const currentIndex = currentImageIndices[item.bankprop_id] || 0;
    const hasMultipleImages = imageUrls.length > 1;
    const isLocationLoading = locationLoadingId === item.bankprop_id;
    const isDeleting = deletingId === item.bankprop_id;
    const daysLeft = getDaysLeftForAuction(item);
    const status = getStatusStyles(item.admin_status);

    const specs = [
      {
        label: "Property Type",
        value: item.property_type,
        icon: <HomeWorkOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: "City/Town",
        value: item.city_town,
        icon: <LocationOn sx={{ fontSize: 15 }} />,
      },
      {
        label: "Bank",
        value: item.bank_name || "SBI",
        icon: <AccountBalanceOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: "Area/Town",
        value: item.area_town,
        icon: <ExploreOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: "Reserve Price",
        value: formatCurrency(item.reserve_price),
        icon: <TagOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: "Auction ID",
        value: item.bankprop_id ? `#${item.bankprop_id}` : null,
        icon: <TagOutlinedIcon sx={{ fontSize: 15 }} />,
      },
    ];

    return (
      <Card
        key={item.bankprop_id}
        onClick={(e) => {
          const isInteractiveElement =
            e.target.closest("button") ||
            e.target.closest("svg") ||
            e.target.closest(".MuiMenu-root") ||
            e.target.closest(".MuiMenuItem-root") ||
            e.target.closest(".MuiButton-root") ||
            e.target.closest(".MuiIconButton-root");
          if (!isInteractiveElement) {
            handleCardClick(item);
          }
        }}
        sx={{
          mb: 1.5,
          mx: 1,
          borderRadius: "14px",
          backgroundColor: colors.cardBackground,
          border: `1px solid ${colors.line}`,
          boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
          overflow: "hidden",
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            boxShadow: "0 6px 18px rgba(0,0,0,0.13)",
            transform: "translateY(-2px)",
          },
        }}
      >
        <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
          {/* ============ TOP ROW: IMAGE (LEFT) + DETAILS (RIGHT) ============ */}
          <Box
            sx={{
              display: "flex",
              gap: 1.2,
              p: 1.2,
              height: 210,
              boxSizing: "border-box",
            }}
          >
            {/* ── Image column ── */}
            <Box
              sx={{
                position: "relative",
                width: "42%",
                height: "100%",
                flexShrink: 0,
                borderRadius: "10px",
                overflow: "hidden",
                backgroundColor: "#F5F5F5",
              }}
            >
              {imageUrls.length > 0 ? (
                <CardMedia
                  component="img"
                  image={imageUrls[currentIndex]}
                  alt="Property"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "#e6e0d4",
                  }}
                >
                  <Typography sx={{ fontWeight: 700, fontSize: "0.7rem", color: "#555" }}>
                    No Image
                  </Typography>
                </Box>
              )}

              {/* Bank Auction pill overlay top-left */}
              <Box
                sx={{
                  position: "absolute",
                  top: 8,
                  left: 8,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  backgroundColor: colors.primary,
                  color: "#F5C842",
                  px: 0.9,
                  py: 0.35,
                  borderRadius: "6px",
                  maxWidth: "90%",
                }}
              >
                <AccountBalanceOutlinedIcon sx={{ fontSize: 12 }} />
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    fontWeight: 700,
                    letterSpacing: "0.3px",
                    lineHeight: 1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  BANK AUCTION
                </Typography>
              </Box>

              {/* Share / More icons top-right */}
              <Box sx={{ position: "absolute", top: 6, right: 6, display: "flex", gap: 0.5 }}>
                <IconButton
                  size="small"
                  sx={{
                    bgcolor: "rgba(255,255,255,0.9)",
                    width: 26,
                    height: 26,
                    "&:hover": { bgcolor: "#fff" },
                  }}
                  onClick={(e) => handleShare(e, item)}
                >
                  <Share sx={{ fontSize: 14 }} />
                </IconButton>
                <IconButton
                  size="small"
                  sx={{
                    bgcolor: "rgba(255,255,255,0.9)",
                    width: 26,
                    height: 26,
                    "&:hover": { bgcolor: "#fff" },
                  }}
                  onClick={(e) => handleMenuOpen(e, item.bankprop_id)}
                >
                  <MoreVert sx={{ fontSize: 14 }} />
                </IconButton>
              </Box>

              {/* Photo count bottom-left */}
              {imageUrls.length > 0 && (
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 8,
                    left: 8,
                    backgroundColor: "rgba(0,0,0,0.65)",
                    color: "#FFFFFF",
                    fontSize: "0.6rem",
                    fontWeight: 600,
                    px: 0.8,
                    py: 0.3,
                    borderRadius: "5px",
                    lineHeight: 1.1,
                    display: "flex",
                    alignItems: "center",
                    gap: 0.3,
                  }}
                >
                  <CollectionsOutlinedIcon sx={{ fontSize: 11 }} />
                  {currentIndex + 1} / {imageUrls.length}
                </Box>
              )}

              {/* Carousel arrows */}
              {hasMultipleImages && (
                <>
                  <IconButton
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: 4,
                      opacity: 0,
                      transform: "translateY(-50%)",
                      backgroundColor: "rgba(255,255,255,0.5)",
                      backdropFilter: "blur(2px)",
                      transition: "opacity 0.2s",
                      "&:hover": { opacity: 1, backgroundColor: "rgba(255,255,255,0.8)" },
                    }}
                    onClick={(e) => prevImage(e, item.bankprop_id, imageUrls.length)}
                  >
                    <ChevronLeft fontSize="small" />
                  </IconButton>
                  <IconButton
                    sx={{
                      position: "absolute",
                      top: "50%",
                      right: 4,
                      opacity: 0,
                      transform: "translateY(-50%)",
                      backgroundColor: "rgba(255,255,255,0.5)",
                      backdropFilter: "blur(2px)",
                      transition: "opacity 0.2s",
                      "&:hover": { opacity: 1, backgroundColor: "rgba(255,255,255,0.8)" },
                    }}
                    onClick={(e) => nextImage(e, item.bankprop_id, imageUrls.length)}
                  >
                    <ChevronRight fontSize="small" />
                  </IconButton>
                </>
              )}

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                onClick={(e) => e.stopPropagation()}
              >
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMenuClose();
                    navigate(`/user-edit-bank-auction/${item.bankprop_id}`);
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteProperty(e, item);
                    handleMenuClose();
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>

            {/* ── Details column ── */}
            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                gap: 0.6,
              }}
            >
              {/* status + posted time */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 0.6,
                  flexWrap: "wrap",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.4,
                    px: 0.8,
                    py: 0.25,
                    borderRadius: "6px",
                    border: `1px solid ${status.border}`,
                    backgroundColor: status.bg,
                    color: status.color,
                  }}
                >
                  {status.icon}
                  <Typography sx={{ fontSize: "0.62rem", fontWeight: 700, lineHeight: 1.1 }}>
                    {status.label}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 0.3 }}>
                  <AccessTimeIcon sx={{ fontSize: 11, color: colors.textMuted }} />
                  <Typography sx={{ fontSize: "0.62rem", color: colors.textMuted }}>
                    {formatDate(item.created_at)}
                  </Typography>
                </Box>
              </Box>

              {/* title */}
              <Typography
                sx={{
                  fontSize: "0.92rem",
                  fontWeight: 800,
                  color: colors.textDark,
                  lineHeight: 1.25,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {item.property_type || "Bank Auction Property"}
              </Typography>

              {/* location */}
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.4 }}>
                <LocationOn
                  sx={{ fontSize: 13, color: colors.textMuted, mt: "1px", flexShrink: 0 }}
                />
                <Typography
                  sx={{
                    fontSize: "0.68rem",
                    color: "#666",
                    lineHeight: 1.3,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {item.location || `${item.city_town || ""}, ${item.area_town || ""}`}
                </Typography>
              </Box>

              {/* auction date range */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.4 }}>
                <CalendarTodayOutlinedIcon sx={{ fontSize: 12, color: colors.textMuted }} />
                <Typography sx={{ fontSize: "0.66rem", color: "#666" }}>
                  {formatDateLong(item.auction_start_datetime)} -{" "}
                  {formatDateLong(item.auction_end_datetime)}
                </Typography>
              </Box>

              {/* days left row */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.4 }}>
                <AccessTimeIcon sx={{ fontSize: 12, color: colors.textMuted }} />
                <Typography
                  sx={{
                    fontSize: "0.8rem",
                    fontWeight: 700,
                    color:
                      daysLeft === null
                        ? "#1976d2"
                        : daysLeft === 0
                        ? "#e53935"
                        : daysLeft <= 7
                        ? "#ff9800"
                        : "#2e7d32",
                  }}
                >
                  {daysLeft === null
                    ? "No Expiry"
                    : daysLeft === 0
                    ? "Expired"
                    : `${daysLeft} days left`}
                </Typography>
              </Box>

              {/* reserve price band */}
              <Box
                sx={{
                  mt: 0.4,
                  px: 1,
                  py: 0.7,
                  borderRadius: "8px",
                  backgroundColor: colors.goldSoft,
                  border: `1px dashed ${colors.gold}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 0.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "0.58rem",
                    fontWeight: 700,
                    color: "#8a6a1f",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    lineHeight: 1.1,
                  }}
                >
                  Reserve Price
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.85rem",
                    fontWeight: 800,
                    color: colors.gold,
                    whiteSpace: "nowrap",
                  }}
                >
                  {formatCurrency(item.reserve_price)}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* ============ SPEC GRID (2 columns) ============ */}
          <Box
            sx={{
              mx: 1.2,
              mb: 1,
              border: `1px solid ${colors.line}`,
              borderRadius: "10px",
              overflow: "hidden",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              backgroundColor: colors.specBg,
            }}
          >
            {specs.map((spec, index) => (
              <SpecCell
                key={spec.label}
                icon={spec.icon}
                label={spec.label}
                value={spec.value}
                index={index}
                total={specs.length}
              />
            ))}
          </Box>

          {/* ============ FOOTER: EXTEND + VIEW + WISHLIST + EDIT + DELETE ============ */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 0.8,
              px: 1.2,
              py: 1,
              borderTop: `1px solid ${colors.line}`,
              backgroundColor: "#FAF8F5",
              flexWrap: "wrap",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap" }}>
              {/* Extend Your Post */}
              <Button
                variant="outlined"
                disabled={daysLeft !== null && daysLeft > 7}
                onClick={handleExtensionClick}
                startIcon={<AccessTimeIcon sx={{ fontSize: 15, color: "#c3790b" }} />}
                sx={{
                  textTransform: "none",
                  borderRadius: "7px",
                  fontSize: "0.66rem",
                  fontWeight: 600,
                  backgroundColor: "#fff",
                  borderColor: "#d0d0d0",
                  color: "#c3790b",
                  px: 1,
                  py: 0.4,
                  whiteSpace: "nowrap",
                  minWidth: 0,
                  "&:hover": { backgroundColor: "#f5f5f5", borderColor: "#d0d0d0" },
                  "&.Mui-disabled": {
                    backgroundColor: "#fff",
                    borderColor: "#d0d0d0",
                    color: "#c3790b",
                    opacity: 0.6,
                  },
                }}
              >
                Extend Your Post
              </Button>

              {/* View */}
              <Box
                onClick={(e) => e.stopPropagation()}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.4,
                  px: 1,
                  py: 0.5,
                  borderRadius: "7px",
                  border: `1px solid ${colors.line}`,
                  backgroundColor: "#fff",
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#F5F0E8" },
                }}
              >
                <VisibilityIcon sx={{ fontSize: 13, color: "#5a5a5a" }} />
                <Typography sx={{ fontSize: "0.66rem", fontWeight: 600, color: "#5a5a5a" }}>
                  View
                </Typography>
              </Box>

              {/* Wishlist */}
              <Box
                onClick={(e) => e.stopPropagation()}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.4,
                  px: 1,
                  py: 0.5,
                  borderRadius: "7px",
                  border: `1px solid ${colors.line}`,
                  backgroundColor: "#fff",
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#F5F0E8" },
                }}
              >
                <FavoriteBorder sx={{ fontSize: 13, color: "#5a5a5a" }} />
                <Typography sx={{ fontSize: "0.66rem", fontWeight: 600, color: "#5a5a5a" }}>
                  Wishlist
                </Typography>
              </Box>
            </Box>

            {/* ── EDIT + DELETE at the very end ── */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, ml: "auto" }}>
              {/* Edit */}
              <Button
                variant="outlined"
                size="small"
                onClick={(e) => handleEditClick(e, item)}
                startIcon={<EditOutlinedIcon sx={{ fontSize: 14 }} />}
                sx={{
                  textTransform: "none",
                  borderRadius: "7px",
                  fontSize: "0.66rem",
                  fontWeight: 600,
                  backgroundColor: "#fff",
                  borderColor: "rgba(184,134,11,0.5)",
                  color: colors.gold,
                  px: 1,
                  py: 0.4,
                  whiteSpace: "nowrap",
                  minWidth: 0,
                  "&:hover": {
                    backgroundColor: "rgba(184,134,11,0.08)",
                    borderColor: colors.gold,
                  },
                }}
              >
                Edit
              </Button>

              {/* Delete */}
              <Button
                variant="outlined"
                size="small"
                disabled={isDeleting}
                onClick={(e) => handleDeleteProperty(e, item)}
                startIcon={
                  isDeleting ? (
                    <CircularProgress size={12} sx={{ color: colors.danger }} />
                  ) : (
                    <DeleteOutline sx={{ fontSize: 14 }} />
                  )
                }
                sx={{
                  textTransform: "none",
                  borderRadius: "7px",
                  fontSize: "0.66rem",
                  fontWeight: 600,
                  backgroundColor: "#fff",
                  borderColor: "rgba(231,76,60,0.5)",
                  color: colors.danger,
                  px: 1,
                  py: 0.4,
                  whiteSpace: "nowrap",
                  minWidth: 0,
                  "&:hover": {
                    backgroundColor: "rgba(231,76,60,0.08)",
                    borderColor: colors.danger,
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#fff",
                    borderColor: "rgba(231,76,60,0.5)",
                    color: colors.danger,
                    opacity: 0.6,
                  },
                }}
              >
                Delete
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  };

  /* ==================== RENDER ==================== */

  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: "rgb(184, 174, 162)",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 3,
        }}
      >
        <CircularProgress size={40} thickness={5} sx={{ color: "#000000" }} />
        <Typography variant="h7" sx={{ color: "#000000", fontWeight: 600 }}>
          Loading Auction Properties...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: colors.background,
        }}
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: colors.background, minHeight: "120vh" }}>
      {/* Fixed Top Section */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
          backgroundColor: colors.background,
          px: 1,
          py: 1,
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#000" }}>
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ fontWeight: "bold", ml: 1 }}>
            My Auction Properties
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 1,
          }}
        >
          <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
            {data.length > 0 && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<RocketIcon sx={{ fontSize: 18 }} />}
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  textTransform: "none",
                  backgroundColor: "#6B3620",
                  color: "#FFFFFF",
                  borderRadius: "8px",
                  padding: "6px 16px",
                  "&:hover": { backgroundColor: "#8A4A2E" },
                }}
              >
                Boost Your Property
              </Button>
            )}
          </Box>
        </Box>
      </Box>

      {/* Property List Section */}
      <Box sx={{ pt: { xs: "110px", sm: "150px" }, pb: 8 }}>
        {data.length === 0 ? (
          <Typography textAlign="center" sx={{ mt: 4 }}>
            No auction properties found
          </Typography>
        ) : (
          data.map((item) => renderAuctionPropertyCard(item))
        )}
      </Box>

      {/* ALERTS */}
      {showDeleteSuccess && (
        <DeleteSuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteSuccess(false);
            setAlertMessage("");
          }}
        />
      )}
      {showDeleteFailure && (
        <DeleteFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteFailure(false);
            setAlertMessage("");
          }}
        />
      )}
      {showDeleteConfirm && propertyToDelete && (
        <DeleteConfirmAlert
          message={`Are you sure you want to delete this auction property? This action cannot be undone.`}
          onOk={() => {
            setShowDeleteConfirm(false);
            performDelete();
          }}
          onCancel={() => {
            setShowDeleteConfirm(false);
            setPropertyToDelete(null);
          }}
        />
      )}

      {/* BOTTOM NAV */}
      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
        <CustomBottomNavbar />
      </Box>
    </Box>
  );
};

export default User_BankAuction;